<app-row align="center" gutter="x-xs">
  <app-col cols="auto" class="h6 m-0">{{label || ('shared.components.sortMenu.sort' | translate)}}</app-col>
  <app-col>
    <div class="selectable-menu__trigger">
      <button mat-flat-button [matMenuTriggerFor]="sortMenu" *ngIf="selectedValue$ | async as selected" [ngStyle]="{ 'color': triggerButtonColor }">
        <ng-container *ngIf="icons[selected.key] as icon">
          <ng-container *ngTemplateOutlet="iconTemplate; context: {$implicit: icon }"></ng-container>
        </ng-container>
        {{translations[selected.key]}}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    </div>
  </app-col>
</app-row>

<mat-menu #sortMenu="matMenu" class="selectable-menu__list">
  <ng-container *ngFor="let option of options">
    <button
      mat-flat-button
      type="button"
      class="selectable-menu__item"
      [class.selectable-menu__item--selected]="option.key === value"
      (click)="select(option)"
    >
      <ng-container *ngIf="icons[option.key] as icon">
        <ng-container *ngTemplateOutlet="iconTemplate; context: {$implicit: icon }"></ng-container>
      </ng-container>
      {{translations[option.key]}}
    </button>
  </ng-container>
</mat-menu>

<ng-template #iconTemplate let-icon>
  <app-icon type="MaterialDesign" [name]="icon.name" *ngIf="icon.type === IconType.MaterialDesign" size="xs"></app-icon>
  <app-icon class="d-inline-block mr-1" *ngIf="icon.type === IconType.SVG" [name]="icon.name" size="xs"></app-icon>
  <img *ngIf="icon.type === IconType.Image" [src]="icon.name" />
</ng-template>
